import { useSelector } from "react-redux/es/hooks/useSelector";
import { CheckOutlined, CommentOutlined, StopOutlined } from "@ant-design/icons";
import { List, Button, Avatar, Typography, Col, Row, notification } from "antd";
import { useEffect, useState } from "react";
import ReactQuill from "react-quill";
import { changeRequestStatus, sendNotificationConfirm, setOwn } from "../../../../../controllers/connection";
import { Contact, RecordStatus, RequestStatus, RequestType } from "../../../..";
import { capitalizeString } from "../../../../../shared/util";
import store from "../../../../../controllers/store";
import { getReceived } from "../../../../../controllers/store/actions/connection/connection-received-actions";
type NotificationType = 'success' | 'info' | 'warning' | 'error';
const { Paragraph, Text } = Typography;
const dispatch = store.dispatch;
const Connections = (props: any) => {
    const [api, contextHolder] = notification.useNotification();
    const [values, setValues] = useState([]);
    const [commentValue, setCommentValue] = useState<string | null>(null);
    const [connection, setConnection] = useState({} as any);
    const [commentText, setCommentTex] = useState<string | null>(null);
    const [toggleComment, setToggleComment] = useState(false);
    const [sendingCommnet, setSendingComment] = useState(false);
    const [loadingRequest, setLoadingRequest] = useState(false);

    const user = useSelector((state: any) => {
        return state.user.user;
    });

    const openNotificationWithIcon = (type: NotificationType) => {
        api[type]({
            message: 'UNAB',
            description: 'Mensaje enviado correctamente',
        });
    };

    useEffect(() => {
        setValues(props.values);
    }, [props.values])

    return (
        <>
            {contextHolder}
            {!toggleComment ? (<List
                dataSource={values}
                locale={{ emptyText: 'Sin registros' }}
                pagination={{
                    total: props.total,
                    onChange: (page) => {
                        console.log(page);
                    },
                    pageSize: 4,
                }}
                renderItem={(connection: any, index) => {
                    return (
                        <>
                            <List.Item actions={[
                                <>{connection.status === RequestStatus.Accepted || connection.status === RequestStatus.Cancelled ? (
                                    <Button type="dashed" disabled size="small">
                                        {connection.status === RequestStatus.Accepted ? 'Confirmada' : 'Cancelada'}
                                    </Button>) : (
                                    <>
                                        {props.type === RequestType.Received ? (<Button onClick={() => {
                                            setLoadingRequest(true);
                                            changeRequestStatus({
                                                id: connection.id,
                                                status: RequestStatus.Accepted
                                            });

                                            if (!connection.owner) {
                                                setOwn(connection.id, user.me.id);
                                            }

                                            setLoadingRequest(false);

                                            const newValues = values.map((c: any) => {
                                                if (c.id === connection.id) {
                                                    return { ...c, status: 'accepted' };
                                                }
                                                return c;
                                            }) as any;

                                            setValues(newValues);

                                            api["success"]({
                                                message: 'UNAB',
                                                description: 'Solicitud confirmada correctamente.',
                                            });
                                        }}
                                            loading={loadingRequest}
                                            size="small"
                                            type='primary'
                                            icon={<CheckOutlined />}>
                                            Confirmar
                                        </Button>) : (null)}

                                        {props.type === RequestType.Sended ? (<Button onClick={() => {
                                            if (props.type === RequestType.Sended) {
                                                setLoadingRequest(true);
                                                changeRequestStatus({
                                                    id: connection.id,
                                                    status: RequestStatus.Cancelled
                                                });
                                                setLoadingRequest(false);
                                            }
                                        }}
                                            loading={loadingRequest}
                                            size="small"
                                            type="default"
                                            icon={<StopOutlined />}>
                                            Cancelar
                                        </Button>) : (null)}
                                    </>
                                )}</>,
                                <>
                                    <Button type="primary" size="small" onClick={() => {
                                        setToggleComment(!toggleComment);
                                        setConnection(connection);
                                    }} icon={<CommentOutlined />} /></>
                            ]} >
                                <List.Item.Meta
                                    avatar={<Avatar src={`https://api.dicebear.com/7.x/miniavs/svg?seed=${index}`} />}
                                    title={<a href="https://ant.design"> {props.type === RequestType.Sended ? connection?.to : connection?.from} </a>}
                                    description={
                                        <Paragraph style={{ marginBottom: '0px' }} ellipsis={{ rows: 2, expandable: true, symbol: 'Más', tooltip: (connection.content || '').toLowerCase() }}>
                                            {connection.content || ''}
                                        </Paragraph>
                                    }
                                />
                            </List.Item>
                        </>
                    )
                }
                }
            />) : (null)}

            {toggleComment ? (
                <div>
                    <ReactQuill
                        placeholder="Respondiendo a la solicitud..."
                        theme="snow"
                        value={commentValue || ''}
                        onChange={(content, delta, source, editor) => {
                            setCommentValue(content)
                            setCommentTex(editor.getText());
                        }}
                    />
                    <p>
                        <Row gutter={[8, 8]}>
                            <Col xs={24} sm={12} md={6} lg={12}>
                                <Button block disabled={!commentText || commentText.length === 1} loading={sendingCommnet} type="primary" onClick={() => {
                                    setSendingComment(true);

                                    sendNotificationConfirm({
                                        from: capitalizeString(`${user.me.first_name} ${user.me.last_name}`),
                                        to: {
                                            email: connection?.to,
                                        },
                                        content: commentText || ''
                                    });
                                    openNotificationWithIcon("success");
                                    setSendingComment(false);
                                    setToggleComment(false);
                                    setCommentValue('');
                                }}>{sendingCommnet ? 'Enviando...' : 'Enviar'}</Button>
                            </Col>
                            <Col xs={24} sm={12} md={6} lg={12}>
                                <Button block type="dashed" onClick={() => {
                                    setCommentValue('');
                                    setToggleComment(false);
                                }}>Cancelar edición</Button>
                            </Col>
                        </Row>
                    </p>
                </div>
            ) : (null)}
        </>
    );
}

export default Connections;